import { AnyAction } from 'redux';

import { userInputActions, UserInputState } from './userInput.types';

export const userInputInitialState: UserInputState = {};

export const userInputReducer: (state: UserInputState | undefined, action: AnyAction) => UserInputState = (
	state = userInputInitialState,
	action
): UserInputState => {
	if (action.type === userInputActions.saveUserInput) {
		return {
			...state,
			...action.payload,
		};
	}
	if (action.type === userInputActions.saveCorporateDataFormInput) {
		return {
			...state,
			forms: {
				...state.forms,
				corporateData: {
					...state.forms?.corporateData,
					...action.payload,
				},
			},
		};
	}
	if (action.type === userInputActions.saveCorporateDataFormIsValidInput) {
		return {
			...state,
			forms: {
				...state.forms,
				corporateData: {
					...state.forms?.corporateData,
					...action.payload,
				},
			},
		};
	}
	if (action.type === userInputActions.saveIntegratorDataFormInput) {
		return {
			...state,
			forms: {
				...state.forms,
				integratorData: {
					...state.forms?.integratorData,
					...action.payload,
				},
			},
		};
	}
	if (action.type === userInputActions.saveIntegratorDataFormIsValidInput) {
		return {
			...state,
			forms: {
				...state.forms,
				integratorData: {
					...state.forms?.integratorData,
					...action.payload,
				},
			},
		};
	}
	if (action.type === userInputActions.clearIntegratorFormInput) {
		return {
			...state,
			forms: {
				...state.forms,
				integratorData: userInputInitialState?.forms?.integratorData,
			},
		};
	}
	if (action.type === userInputActions.clearUserInput) {
		return {
			...userInputInitialState,
		};
	}
	return state;
};
